import { useEffect } from 'react';

// Simple social analytics tracking
// In production, you might want to integrate with Google Analytics, Mixpanel, or similar

export default function SocialAnalytics() {
  useEffect(() => {
    // Listen for share button clicks
    const handleShareClick = (event) => {
      const button = event.target.closest('[data-share-platform]');
      if (button) {
        const platform = button.getAttribute('data-share-platform');
        const page = window.location.pathname;

        // Track the share event
        trackShare(platform, page);

        // You can integrate with analytics services here
        console.log(`Share event: ${platform} - ${page}`);
      }
    };

    // Listen for copy link clicks
    const handleCopyClick = (event) => {
      const button = event.target.closest('[data-copy-link]');
      if (button) {
        const page = window.location.pathname;

        trackCopyLink(page);
        console.log(`Copy link: ${page}`);
      }
    };

    document.addEventListener('click', handleShareClick);
    document.addEventListener('click', handleCopyClick);

    return () => {
      document.removeEventListener('click', handleShareClick);
      document.removeEventListener('click', handleCopyClick);
    };
  }, []);

  return null; // This component doesn't render anything
}

// Analytics tracking functions
function trackShare(platform, page) {
  // Send to analytics service
  if (typeof gtag !== 'undefined') {
    gtag('event', 'share', {
      event_category: 'social',
      event_label: platform,
      page_path: page
    });
  }

  // You could also send to your own analytics endpoint
  // fetch('/api/analytics/share', {
  //   method: 'POST',
  //   body: JSON.stringify({ platform, page }),
  //   headers: { 'Content-Type': 'application/json' }
  // });
}

function trackCopyLink(page) {
  // Send to analytics service
  if (typeof gtag !== 'undefined') {
    gtag('event', 'copy_link', {
      event_category: 'social',
      event_label: 'clipboard',
      page_path: page
    });
  }
}

// Export tracking functions for use in other components
export { trackShare, trackCopyLink };
